<template>
    <div class="container">
        <div class="footers">
            <div class="wrapper">
                <div class="text-top">
                    <div class="text-item">
                        <dl class="title">About Yedeer</dl>
                        <dl class="list lianxi">
                            <dd class="item" title="+86 531 68659135">Contact Us： +86 531 68659135</dd>
                            <dd class="item" title="Yedeer2022@gmail.com">Email：Yedeer2022@gmail.com</dd>
                            <dd class="item" title="besesun.translator@gmail.com">Facebook：besesun.translator@gmail.com</dd>
                            <dd class="item" title="+86 155 6245 7065">WhatsApp/Telegram/WeChat：+86 155 6245 7065</dd>
                        </dl>
                    </div>
                    <div class="text-item flex-center">
                        <dl class="title">Follow us</dl>
                        <dl class="list ">
                        <a class="lo lo1" target="_blank" title="Facebook" href="https://www.facebook.com/profile.php?id=100082511291974"></a>
                        <a class="lo lo2" target="_blank" title="Twitter" href="https://twitter.com/YedeerB"></a>
                        <a class="lo lo3" target="_blank" title="whatsapp" href="https://api.whatsapp.com/send?phone=8615562457065"></a>
                        </dl>
                    </div>
                    <div class="text-item">
                        <dl class="title">Join us</dl>
                        <dl class="list ofqrcode">
                            <div class="qrcode" title="QR Code of Official Wechat Group">
                                <img src="@/assets/images/twitter.png" class="imgs" title="Twitter" alt="Twitter" >
                                <p>Twitter</p>
                            </div>
                            <div class="qrcode" title="QR Code of Official Wechat Group">
                                <img src="@/assets/images/Instagram.png" class="imgs" title="Instagram" alt="Instagram" >
                                <p>Instagram</p>
                            </div>
                            <div class="qrcode" title="QR Code of Official Wechat Group">
                                <img src="@/assets/images/TikTok.png" class="imgs" title="TikTok" alt="TikTok" >
                                <p>TikTok</p>
                            </div>
                        </dl>
                    </div>
                </div>
                
            </div>
        </div>
    </div>
</template>

<script>
export default {

}
</script>

<style lang="less" scoped>

a{
    text-decoration: none;
}
.container{
    padding-bottom: 3.19rem;
    background-color: #F1F3F4;
    .footers{
        .wrapper{
            text-align: left;
            // width: 100vw;
            margin:0 auto;
            padding: 0  0.75rem;
            .text-top{
              .text-item{
                margin-top: 1rem;
                // about yedeers
                .title{
                    display: block;
                    // min-width: 5rem;
                    // width: 5rem;
                    // background-color: #fff;
                    height: 0.88rem;
                    line-height: 0.88rem;
                    font-family: MicrosoftYaHei;
                    font-size: 0.80rem;
                    color: #000000;
                    font-weight: 600;
                }
                .list{
                    display: flex;
                    flex-wrap: wrap;
                    &.lianxi{
                        display: block;
                    }
                    .item{
                        height: 0.56rem;
                        line-height: 0.56rem;
                        font-family: MicrosoftYaHeiLight;
                        font-size: 0.65rem;
                        // font-size: 0.28rem;
                        color: #000000;
                        text-align: left;
                        margin-top: 0.75rem;

                    }
                    // follow us
                    .lo{
                        background:no-repeat  center center/cover;
                        width: 1.06rem;
                        height: 1.06rem;
                        margin-left: 0.75rem;
                        // background-color: #c00;
                    }
                    .lo:first-child{
                        margin: 0;
                    }
                    .lo1{
                        background-image:url(@/assets/images/facebook.svg) ;
                    }
                    .lo2{
                        background-image:url(@/assets/images/twitter.svg) ;
                    }
                    .lo3{
                        background-image:url(@/assets/images/whatsapp.svg) ;
                    }
                    &.ofqrcode{
                        justify-content: center;
                    }
                }
                &.flex-center{
                    display: flex;
                    align-items: center;
                    .list{
                        margin-left: 1.81rem;

                    }
                }
                
                .qrcode{
                    margin-left: 0.75rem;
                    margin-top: 1rem;
                    P{
                        font-size: 0.75rem;
                        text-align: center;
                        margin-top: 0.5rem;
                        font-weight: 600;
                    }
                    &:first-child{
                        margin-left:0;
                    }
                    .imgs{
                        width: 6rem;
                        height: 6rem;
                        // background: #D8D8D8;
                        border-radius: 0.25rem;
                    }
                }
              }  
            }
        }
    }
}

</style>